import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Provider.Save.IRequest;
type Response = Api.Core.Provider.Save.IResponse;
type Headers = Api.Core.Provider.Save.IHeaders;
const url = '/api/ProductManagement/Provider';
export default async function providerSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
